import { Options, Vue } from 'vue-class-component';
import {
  ComponentType,
  ConfigurationType,
  DeviceDTO,
  ILinkableObject,
  SlotStatus,
  Slot,
} from '@/../client-generator/generated-clients/plants';
import { PropType } from 'vue';
import SlotListItem from './SlotItem/SlotListItem.vue';
import SlotItemOverview from './SlotItem/SlotItemOverview.vue';
import { SlotRuleServiceType } from '@/core/services/slots-assign-rules-service/slots-assign-rules-interfaces';
import DeviceSlotsListOverview from '@/views/components/DeviceAndSlotDetail/DeviceSlotsListOverview/DeviceSlotsListOverview.vue';

type SlotExtended = Slot & {
  showBar?: boolean;
};

@Options({
  name: 'DeviceAndSlotDetail',
  props: {
    device: {
      type: Object as PropType<DeviceDTO>,
      required: true,
    },
    isAdd: {
      type: Boolean,
      required: true,
    },
    isSingleDeviceSelection: {
      type: Boolean,
      default: false,
    },
    isOnlyDeviceSelection: {
      type: Boolean,
      default: false,
    },
    linkableObject: {
      type: Object as PropType<ILinkableObject>,
      required: true,
    },
    ruleServiceType: {
      type: Number,
      required: true,
    },
  },
  emits: ['add-device', 'remove-device'],
  components: {
    SlotListItem,
    SlotItemOverview,
    DeviceSlotsListOverview,
  },
})
export default class DeviceAndSlotDetail extends Vue {
  SlotStatus = SlotStatus;
  device!: DeviceDTO;
  isAdd!: boolean;
  isSingleDeviceSelection!: boolean;
  isOnlyDeviceSelection!: boolean;
  linkableObject!: ILinkableObject;
  ruleServiceType!: SlotRuleServiceType;
  isExpanded = false;

  get compatibleComponentTypes() {
    switch (this.ruleServiceType) {
      case SlotRuleServiceType.AUTOMATION_ACTUATOR:
        return [ComponentType.Actuator, ComponentType.None];
      case SlotRuleServiceType.AUTOMATION_COMMAND:
      case SlotRuleServiceType.COMMANDS_AND_GROUPS:
        return [ComponentType.Command, ComponentType.None];
      case SlotRuleServiceType.THERMO_HEATING_ACTUATORS:
      case SlotRuleServiceType.THERMO_COOLING_ACTUATORS:
      case SlotRuleServiceType.THERMO_SHARED_ACTUATORS:
      case SlotRuleServiceType.THERMO_HEATING_PUMPS:
      case SlotRuleServiceType.THERMO_COOLING_PUMPS:
      case SlotRuleServiceType.THERMO_SHARED_PUMPS:
        return [ComponentType.Actuator, ComponentType.None];
    }
  }

  get compatibleSlots() {
    const slots: SlotExtended[] | undefined = this.device.slots?.filter(
      (k) =>
        !k.isSetting &&
        (this.device.componentTypes?.includes(
          ComponentType.ShutterActuatorCommand
        ) ||
          (k.assignedComponentType &&
            this.compatibleComponentTypes?.includes(k.assignedComponentType)))
    );

    slots?.forEach((s, i) => {
      if (
        (s.configurationType === ConfigurationType.Mostrine &&
          slots[i - 1] &&
          slots[i - 1].configurationType === ConfigurationType.Mostrine) ||
        (s.configurationType === ConfigurationType.Mostrine &&
          slots[i + 1] &&
          slots[i + 1].configurationType === ConfigurationType.Mostrine)
      ) {
        // @ts-ignore
        s.showBar = true;
      }
    });

    return slots;
  }

  addDevice() {
    this.$emit('add-device', JSON.parse(JSON.stringify(this.device)));
  }

  removeDevice() {
    this.$emit('remove-device', this.device);
  }

  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }
}
